import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { ComposeEmailProvider } from './context/ComposeEmailContext';
import { JobAssigneesProvider } from './context/JobAssigneesContext';
import { AuthCallback } from './components/AuthCallback';
import { ProtectedRoute } from './components/ProtectedRoute';
import { MainLayout } from './components/MainLayout';
import { ComposeEmailDrawer } from './components/ComposeEmailDrawer';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { OrganizationsPage } from './pages/OrganizationsPage';
import { ContactsPage } from './pages/ContactsPage';
import { EmailHubPage } from './pages/EmailHubPage';
import { EmailAuditPage } from './pages/EmailAuditPage';
import { WorkflowsPage } from './pages/WorkflowsPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { SettingsPage } from './pages/SettingsPage';
import { BillingPage } from './pages/BillingPage';
import { GodModePage } from './pages/GodModePage';
import { ExportDataPage } from './pages/ExportDataPage';
import CalendarPage from './pages/CalendarPage';
import CheckOrdersPage from './pages/CheckOrdersPage';
import AutomationPage from './pages/AutomationPage';
import AssistMePage from './pages/AssistMePage';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Router component that checks for session_id in URL hash
const AppRouter = () => {
  const location = useLocation();
  
  // Check URL fragment for session_id (legacy Emergent Auth) or
  // session_token (new unified Google OAuth) - synchronous during render.
  if (location.hash?.includes('session_id=') || location.hash?.includes('session_token=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/organizations" element={<OrganizationsPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/email-hub" element={<EmailHubPage />} />
        <Route path="/email-audit" element={<EmailAuditPage />} />
        <Route path="/workflows" element={<WorkflowsPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/check-orders" element={<CheckOrdersPage />} />
        <Route path="/export-data" element={<ExportDataPage />} />
        <Route path="/automation" element={<AutomationPage />} />
        <Route path="/assist-me" element={<AssistMePage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/billing" element={<BillingPage />} />
        <Route path="/godmode" element={<GodModePage />} />
      </Route>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <JobAssigneesProvider>
        <ComposeEmailProvider>
          <BrowserRouter>
            <AppRouter />
            {/* Global slide-in compose drawer (opens via useComposeEmail()).
                Lives outside <Routes /> so it persists across page switches
                and can be minimised while the user keeps working. */}
            <ComposeEmailDrawer />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </ComposeEmailProvider>
        </JobAssigneesProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
